import React from 'react'

const DiwaliPopup = () => {
  const bursts = [
    'burst-one',
    'burst-two',
    'burst-three',
    'burst-four',
    'burst-five',
    'burst-six',
    'burst-seven',
    'burst-eight'
  ]

  const particles = Array.from({ length: 24 }, (_, i) => i + 1)

  return (
    <div className='diwali-overlay'>
      {/* Firework bursts */}
      <div className='diwali-effects'>
        {bursts.map(burst => (
          <div key={burst} className={`spark-burst ${burst}`} />
        ))}

        {/* Golden floating particles */}
        {particles.map(particle => (
          <div
            key={particle}
            className={`spark-particle particle-${particle}`}
          />
        ))}
      </div>

      <style>{`
        .diwali-overlay {
          position: fixed;
          inset: 0;
          z-index: 9999;
          overflow: hidden;
          pointer-events: none;
        }

        .diwali-effects {
          position: absolute;
          inset: 0;
          overflow: hidden;
          pointer-events: none;
        }

        /* Firework burst */
        .spark-burst {
          position: absolute;
          width: 118px;
          height: 118px;
          border-radius: 50%;
          opacity: 0;

          background:
            radial-gradient(
              circle,
              #fff 0 1.5%,
              #fff2a6 2.5% 4%,
              transparent 6%
            ),
            repeating-conic-gradient(
              from 0deg,
              transparent 0deg 5deg,
              rgba(255, 239, 170, .98) 5.5deg 6.4deg,
              transparent 7deg 13deg
            );

          -webkit-mask-image: radial-gradient(
            circle,
            transparent 0 5%,
            #000 11% 58%,
            transparent 74%
          );

          mask-image: radial-gradient(
            circle,
            transparent 0 5%,
            #000 11% 58%,
            transparent 74%
          );

          filter:
            drop-shadow(0 0 4px rgba(255, 225, 120, .95))
            drop-shadow(0 0 13px rgba(255, 155, 35, .75));

          animation: diwaliBurst 4.8s ease-out infinite;
          will-change: transform, opacity;
        }

        .spark-burst::before,
        .spark-burst::after {
          content: '';
          position: absolute;
          inset: 18%;
          border-radius: 50%;

          background: repeating-conic-gradient(
            transparent 0deg 8deg,
            rgba(255, 185, 65, .95) 8.5deg 9.5deg,
            transparent 10deg 18deg
          );

          -webkit-mask-image: radial-gradient(
            circle,
            transparent 0 12%,
            #000 20% 58%,
            transparent 72%
          );

          mask-image: radial-gradient(
            circle,
            transparent 0 12%,
            #000 20% 58%,
            transparent 72%
          );

          transform: rotate(12deg);
        }

        .spark-burst::after {
          inset: 36%;
          background: radial-gradient(
            circle,
            #fff 0 10%,
            #ffdb72 25%,
            transparent 72%
          );
          filter: blur(2px);
          -webkit-mask-image: none;
          mask-image: none;
        }

        /* Firework positions */
        .burst-one {
          top: 10%;
          right: 13%;
          animation-delay: 0s;
        }

        .burst-two {
          top: 43%;
          right: 43%;
          width: 78px;
          height: 78px;
          animation-delay: 1.05s;
        }

        .burst-three {
          bottom: 13%;
          right: 9%;
          width: 96px;
          height: 96px;
          animation-delay: 2.1s;
        }

        .burst-four {
          top: 20%;
          left: 38%;
          width: 70px;
          height: 70px;
          animation-delay: 2.8s;
        }

        .burst-five {
          top: 62%;
          left: 12%;
          width: 88px;
          height: 88px;
          animation-delay: 3.45s;
        }

        .burst-six {
          top: 7%;
          left: 8%;
          width: 62px;
          height: 62px;
          animation-delay: 1.65s;
        }

        .burst-seven {
          bottom: 24%;
          left: 54%;
          width: 72px;
          height: 72px;
          animation-delay: 4.05s;
        }

        .burst-eight {
          top: 38%;
          right: 5%;
          width: 58px;
          height: 58px;
          animation-delay: 2.45s;
        }

        /* Burst animation */
        @keyframes diwaliBurst {
          0% {
            opacity: 0;
            transform: scale(.08) rotate(0deg);
          }

          9% {
            opacity: 1;
          }

          42% {
            opacity: .95;
            transform: scale(1.12) rotate(28deg);
          }

          72% {
            opacity: .5;
            transform: scale(1.42) rotate(52deg);
          }

          100% {
            opacity: 0;
            transform: scale(1.8) rotate(78deg);
          }
        }

        /* Floating golden sparks */
        .spark-particle {
          position: absolute;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          opacity: 0;

          background: #fff2b0;

          box-shadow:
            0 0 5px 2px rgba(255, 230, 140, .95),
            0 0 13px 4px rgba(255, 165, 40, .65);

          animation: diwaliEmber 3.4s ease-in-out infinite;
          will-change: transform, opacity;
        }

        @keyframes diwaliEmber {
          0%, 100% {
            opacity: 0;
            transform: translate3d(0, 14px, 0) scale(.35);
          }

          25% {
            opacity: .9;
          }

          55% {
            opacity: 1;
            transform: translate3d(12px, -16px, 0) scale(1.45);
          }

          80% {
            opacity: .45;
            transform: translate3d(-5px, -30px, 0) scale(.7);
          }
        }

        /* Particle positions and timing */
        ${particles
          .map(
            i => `
          .particle-${i} {
            top: ${
              [
                17, 31, 52, 74, 13, 36, 69, 83, 24, 57, 9, 88, 44, 63, 28, 78,
                7, 47, 91, 18, 58, 38, 80, 11
              ][i - 1]
            }%;
            left: ${
              [
                16, 29, 8, 23, 57, 68, 61, 79, 87, 91, 42, 43, 48, 35, 76, 9,
                73, 19, 66, 95, 76, 38, 54, 27
              ][i - 1]
            }%;
            animation-delay: ${(i * 0.37) % 3.4}s;
          }
        `
          )
          .join('')}

        /* Mobile */
        @media (max-width: 820px) {
          .spark-burst {
            width: 68px;
            height: 68px;
          }

          .burst-two,
          .burst-four,
          .burst-six,
          .burst-seven,
          .burst-eight {
            width: 48px;
            height: 48px;
          }
        }

        /* Accessibility */
        @media (prefers-reduced-motion: reduce) {
          .spark-burst,
          .spark-particle {
            animation: none;
            opacity: .35;
          }
        }
      `}</style>
    </div>
  )
}

export default DiwaliPopup
